import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material'

interface PDFSuccessDialogProps {
  open: boolean
  pdfContentDocumentId: string | null
  instanceUrl?: string
  onClose: () => void
}

export function PDFSuccessDialog({ open, pdfContentDocumentId, instanceUrl, onClose }: PDFSuccessDialogProps) {
  const handleDownload = () => {
    if (pdfContentDocumentId) {
      const downloadUrl = `https://life-is-tech.file.force.com/sfc/servlet.shepherd/document/download/${pdfContentDocumentId}?operationContext=S1`
      window.open(downloadUrl, '_blank')
    }
    onClose()
  }

  const handleViewFile = () => {
    if (pdfContentDocumentId && instanceUrl) {
      const pdfUrl = `${instanceUrl}/lightning/r/ContentDocument/${pdfContentDocumentId}/view`
      window.open(pdfUrl, '_blank')
    }
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>PDF作成完了</DialogTitle>
      <DialogContent>
        <Typography>PDFの作成が完了しました。Salesforce Filesに保存されています。</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>閉じる</Button>
        <Button variant="outlined" onClick={handleDownload}>
          ダウンロード
        </Button>
        <Button variant="contained" onClick={handleViewFile}>
          ファイルを見る
        </Button>
      </DialogActions>
    </Dialog>
  )
}
